export default __webpack_public_path__ + "static/media/ab-test-dark.25cfc32f.svg";